import store from '../../store';
import { mapState } from 'vuex';
export default class WhatsAppOpenInboxEvent {
  constructor(body) {
    window.console.log(
      '[WhatsAppOpenInboxEvent]',
      JSON.parse(JSON.stringify(body)),
    );
    // console.log("%cRecebi o seguinte protocolo de fila :" + JSON.parse(JSON.stringify(body)), "color:#fff;background:#08c;padding:5px;border-radius:8px")
    console.log(
      '%cEstou vendo? :' + JSON.stringify(store),
      'color:#fff;background:#08c;padding:5px;border-radius:8px',
    );
    if (!store.state.jobs.inbox.inboxInProccess.includes(body.protocol)) {
      //     store.dispatch('jobs/addInboxInProccess', body.protocol)
      //     store.dispatch('jobs/whatsappReopen', {
      //         protocol: body.protocol,
      //         agent_id: body.agentId
      //     })
    }
  }
}
